export const Errors = {
  'not authorized':
    "You are not authorized to use this feature. Reach for one of you company's admins for support.",
  'asana not installed':
    'Your company does not have the Asana integration installed. Please, install it before linking tasks.',
  'asana not configured':
    'Your company does not have the Asana integration fully configured. Please, configure it before linking tasks.',
  'could not connect to asana': `Could not connect to Asana. Please try again later.`,
};
